var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39844 1.59961C5.73094 1.59961 5.99844 1.86711 5.99844 2.19961V3.19961H9.99844V2.19961C9.99844 1.86711 10.2659 1.59961 10.5984 1.59961C10.9309 1.59961 11.1984 1.86711 11.1984 2.19961V3.19961H11.9984C12.8809 3.19961 13.5984 3.91711 13.5984 4.79961V11.9996C13.5984 12.8821 12.8809 13.5996 11.9984 13.5996H3.99844C3.11594 13.5996 2.39844 12.8821 2.39844 11.9996V4.79961C2.39844 3.91711 3.11594 3.19961 3.99844 3.19961H4.79844V2.19961C4.79844 1.86711 5.06594 1.59961 5.39844 1.59961ZM5.39844 4.39961H3.99844C3.77844 4.39961 3.59844 4.57961 3.59844 4.79961V5.99961H12.3984V4.79961C12.3984 4.57961 12.2184 4.39961 11.9984 4.39961H5.39844ZM3.59844 7.19961V11.9996C3.59844 12.2196 3.77844 12.3996 3.99844 12.3996H11.9984C12.2184 12.3996 12.3984 12.2196 12.3984 11.9996V7.19961H3.59844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.66a6a1dbc4237cd5b5bfa28e35a3a6c8.svg";
export { ForwardRef as ReactComponent };